const cookieUiTexts = {
	text: 'Vi bruger cookies til at identificere dig og gemme spildata. Ved at klikke på \'OK\' accepterer du vores brug af cookies. Du kan ikke spille uden at acceptere.',
	btn: 'Ok',
};

const generalUiTexts = {
	title: 'Klik på grisen',
	start: 'Start',
	quizzes: 'Quizzer',
	didYouKnow: 'Noget at tygge på',
	loadingGame: 'Henter spil',
	exit: 'Exit'
};

const challengeUiTexts = {
	ready: 'Klar',
	start: 'Start',
	playAgain: 'Spil igen',
	back: 'Tilbage',
	choose: 'Vælg',
	answers: 'svar',
	next: 'Næste',
	next2: 'Videre',
	hintTitle: 'Hint',
	getAHint: 'Få et <span>hint</span>',
	getAnotherHint: 'Få et <span>hint</span> mere',
	viewDrawing: 'Se tegning',
	viewImage: 'Se billede',
	orderInstruction: 'Sæt tingene i rækkefølge:',
	getCluePopup: {
		title: 'OBS!',
		text: 'Jo flere hints du får, jo færre point får du.<br />Vil du have et hint?',
		buttons: {ok: 'Ja', cancel: 'Nej'}
	},
	newPointTierPopup: {
		title: 'Godt gået!',
		text: 'Du har nu fået point nok til at blive lige så cool som ',
		buttons: {ok: 'Ok'}
	},
	streakPopup: {
		title: 'Godt gået!',
		text: '%answers% rigtige svar i træk:',
		text2: 'Og du har nu fået point nok til at blive lige så cool som ',
		buttons: {ok: 'Videre'}
	},	
	gameCompletedPopup: {
		title: 'Score: %points%p',
		text: 'Tillykke. Nu er du nået til rejsens ende.<br /><br />Gå til dagens topscorerliste for at se, hvordan du har klaret dig.'
	},
	points: 'Point',
	themeCompleted: [
		{
			title: 'Godt gået!',
			text: 'Du svarede på alle spørgsmålene og fik 1 grisehale!<br />Prøv igen og se om du kan få endnu flere næste gang.'
		},
		{
			title: 'Godt gået!',
			text: 'Du svarede på alle spørgsmålene og fik 2 grisehaler!<br />Prøv igen og se om du kan få endnu flere næste gang.'
		},
		{
			title: 'Godt gået!',
			text: 'Du svarede på alle spørgsmålene og fik 3 grisehaler!<br />Prøv igen og se om du kan få endnu flere næste gang.'
		},
		{
			title: 'Fantastisk klaret!',
			text: 'Du svarede på alle spørgsmålene og fik 4 grisehaler!<br />Gå tilbage og prøv en af de andre quizzer!'
		}
	],
	allThemesCompleted: 'Tillykke! Du har løst alle opgaver i spillet.'
}

module.exports = {
	cookieUiTexts,
	generalUiTexts,
	challengeUiTexts
};
